import React from 'react';
import PropTypes from 'prop-types';
import { useIsSpotlightSportSupported } from '../useSpotlight';
import SpotlightWidget from './SpotlightWidget';

const Spotlight = props => {
    const { sportSlug } = props;
    const isSpotlightSportSupported = useIsSpotlightSportSupported(sportSlug);

    if (!isSpotlightSportSupported) {
        return null;
    }

    return <SpotlightWidget {...props} />;
};

Spotlight.propTypes = {
    sportSlug: PropTypes.string,
};

Spotlight.defaultProps = {
    sportSlug: '',
};

export default Spotlight;
